// notes-nebula/index.ts
import top from "./top.jpg";

const NotesNebula = {
  top,
};

export default NotesNebula;

// 個別エクスポート
export { top as notesNebulaTop };
